import { render, staticRenderFns } from "./weiXinLogin.vue?vue&type=template&id=0595fc65"
import script from "./weiXinLogin.vue?vue&type=script&lang=js"
export * from "./weiXinLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports